import CryptoJS from "crypto-js";

export const handleDecryptData = (data) => {

  const CRYPTKEY = 'e33b5c9c6c0998bc';
  const CRYPTIV = 'NcRfUjWnZr4u7x';

  const cryptkey = CryptoJS.enc.Utf8.parse(CRYPTKEY);
  const cryptiv = CryptoJS.enc.Utf8.parse(CRYPTIV);

  const decrypted = CryptoJS.AES.decrypt(data, cryptkey, {
    iv: cryptiv,
    mode: CryptoJS.mode.CTR,
  });
  
  const data2 = decrypted?.toString(CryptoJS.enc.Utf8);
  
  if (data2) return JSON.parse(data2);
};

